<template>
  <div class="w-select" v-clickoutside="handleClickSide">
    <button :disabled="disabled" class="select flex-between" @click="changeOption">
      <span v-show="!disabled" class="selected"
            :class="{'placeholder': !selected.name}">{{ selected.name || placeholder }}</span>
      <span class="iconfont" :class="optionsShow ? 'iconchevron-up' : 'iconchevron-down'"/>
    </button>
    <div class="select-list" v-if="optionsShow"
         :style="options.length < 4 ? `height: ${44 * options.length}px` : 'height: 133px'">
      <cube-scroll :data="options" ref="scroll">
        <ul class="option">
          <li class="option-item" :class="{'is-selected': item.value === selected.value}"
              v-for="(item,index) in options" @click="selectValue(item)" :key="index" :value="item.value">{{ item.name
            }}
          </li>
        </ul>
      </cube-scroll>
    </div>
  </div>
</template>

<script>
	import clickoutside from '@/assets/js/clickoutside'

	export default {
		name: 'w-select',
		props: {
			options: {
				type: Array,
				default: () => []
			},
			// 选中之后给哪个字段赋值
			field: {
				type: String,
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				optionsShow: false,
				selected: {}
			}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			changeOption () {
				this.optionsShow = !this.optionsShow
			},
			selectValue (item) {
				this.selected = item
				this.$emit('selectValue', item, this.field)
				this.optionsShow = false
			},
			handleClickSide () {
				this.optionsShow = false
			}
		},
		directives: {
			clickoutside
		}
	}
</script>

<style lang="scss" scoped>
  .w-select {
    position: relative;
    .select {
      position: relative;
      border: 1px solid #cecece;
      border-radius: 2px;
      background-color: #ffffff;
      width: 100%;
      height: 40px;
      padding-left: 14px;
      outline: none;
      &:disabled {
        border-color: #cecece;
        background-color: #f8f8f8;
        color: #bcbcbc;
        .iconfont {
          color: #bcbcbc;
        }
      }
      .selected {
        font-size: 14px;
        color: #404040;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 240px;
      }
      .placeholder {
        color: #909090;
      }
      .iconfont {
        position: absolute;
        right: 14px;
        font-size: 22px;
        color: #606060;
        font-weight: bold;
      }
      .select-down {
        animation: ratote 0.2s;
      }
    }
    .select-list {
      border: 1px solid #cecece;
      margin-top: 6px;
      .option {
        width: 100%;
        background-color: #ffffff;
        border-radius: 2px;
        z-index: 21;
        .option-item {
          list-style: none;
          height: 44px;
          line-height: 44px;
          color: #404040;
          padding: 0 18px;
          border-bottom: 1px solid #e4e4e4;
          max-width: px2rem(280px);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:last-child {
            border: none;
          }
        }
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
      height: 100%;
      opacity: 0;
    }
  }
</style>
